import React, { useEffect, useState } from "react";
import Layout from "../../../components/layouts/Layout";
import StudentOverviewCard from "../../../components/partials/students/StudentOverviewCard";
import { authHeader } from "../../../utils";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ERROR } from "../../../store/types";
import Loader from "../../../components/elements/Loader";
// import StudentOverview from '../../../components/partials/students/StudentOverview';
import StudentDetails from "../../../components/partials/students/StudentDetails";
import StudentAcademics from "../../../components/partials/students/StudentAcademics";
// import StudentClassSchedule from '../../../components/partials/students/StudentClassSchedule';
import StudentExeatsCheckIns from "../../../components/partials/students/StudentExeatsCheckIns";
import StudentDisciplinary from "../../../components/partials/students/StudentDisciplinary";
import StudentFeedback from "../../../components/partials/students/StudentFeedback";
import { fetchDocumentRequests } from "../../../store/actions/documentRequestActions";
import Breadcrumbs from "../../../components/elements/Breadcrumbs";
import StudentSundry from "../../../components/partials/students/StudentSundry";
import StudentMedicals from "../../../components/partials/students/StudentMedicals";
import StudentInvoices from "../../../components/partials/students/StudentInvoices";
import InlinePreloader from "../../../components/elements/InlinePreloader";
import ArrowDownTrayIcon from "../../../components/elements/icons/ArrowDownTrayIcon";
import ChevronIcon from "../../../components/elements/icons/ChevronIcon";
import { fetchStudentScholarships } from "../../../store/actions/scholarshipsActions";
// import AcademicTranscript from "../../../components/partials/students/AcademicTranscript";
import StudentResultsCompilation from "../../../components/partials/students/StudentResultsCompilation";
import StudentResults from "../../../components/partials/students/StudentResults";
import useHorizontalScroller from "../../../hooks/useHorizontalScroller";
import StudentOverview from "../../../components/partials/students/StudentOverview";

const Student = () => {
  const breadcrumbsData = [
    {
      label: "Dashboard",
      path: "/admin/dashboard",
    },
    {
      label: "Students",
      path: "/admin/students",
    },
    {
      label: "",
      path: "",
      current: true,
    },
  ];

  const { studentId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [studentDetails, setStudentDetails] = useState(null);
  const [reload, setReload] = useState(0);
  // const scholarshipsSelector = useSelector(state => state.scholarships)

  useEffect(() => {
    dispatch(fetchDocumentRequests(`student=${studentId}`));
    dispatch(fetchStudentScholarships(`student=${studentId}`));
    const fetchStudent = async () => {
      try {
        const headers = authHeader();

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/students/${studentId}?expand=class.class,class.division,parent,application`,
          { headers },
        );

        setStudentDetails(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error(error);
        dispatch({
          type: ERROR,
          error,
        });
        setLoading(false);
      }
    };

    fetchStudent();

    return () => {};
  }, [studentId, dispatch, reload]);

  const studentTabs = [
    {
      label: "Overview",
      value: "overview",
    },
    {
      label: "Student Details",
      value: "details",
    },
    {
      label: "Medicals",
      value: "medicals",
    },
    {
      label: "Invoices",
      value: "invoices",
    },
    {
      label: "Academics",
      value: "academics",
    },
    {
      label: "Results",
      value: "term-results",
      hideTab: true,
    },
    {
      label: "Transcript",
      value: "academic-transcript",
      hideTab: true,
    },
    {
      label: "New Results Compilation",
      value: "compile-results",
      hideTab: true,
    },
    // {
    //   label: "Class Schedule",
    //   value: 'schedule'
    // },
    {
      label: "Check-ins & Exeats",
      value: "check-in-exeats",
    },
    {
      label: "Sundry",
      value: "sundry",
    },
    {
      label: "Feedback",
      value: "feedback",
    },
    {
      label: "Disciplinary Records",
      value: "disciplinary",
    },
  ];

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    scrollByDirection,
  } = useHorizontalScroller({ watchKey: activeTabIndex });

  const changeTab = (tabIndex) => {
    setActiveTabIndex(tabIndex);
  };

  const [savingPdf, setSavingPdf] = useState(false);

  // download application as pdf
  const downloadStudentData = async () => {
    try {
      const headers = authHeader();
      setSavingPdf(true);

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/students/${studentId}/export/pdf`,
        {
          headers,
          responseType: "blob",
        },
      );

      // Create a blob URL
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create a temporary link and trigger download
      const link = document.createElement("a");
      link.href = url;
      link.download = `student-${studentDetails.admissionNumber}.pdf`;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setSavingPdf(false);
    } catch (error) {
      console.log("error downloading application: ", error);
      dispatch({
        type: ERROR,
        error,
      });
      setSavingPdf(false);
    }
  };

  const toggleTabFromValue = (tabValue) => {
    const tabIndex = studentTabs.findIndex((tab) => tab.value === tabValue);
    tabIndex > -1 && setActiveTabIndex(tabIndex);
  };

  return (
    <Layout pageTitle={`Student Profile`}>
      <div className="w-full pb-2">
        <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        {
          loading ? (
            <Loader />
          ) : (
            <div className="flex items-start gap-x-8">
              <div className="w-[250px] sticky top-[100px]">
                <StudentOverviewCard student={studentDetails} reload={()=>{setReload(reload => reload + 1)}} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="w-full min-w-0">
                  <label className="text-xs tracking-[0.2em] uppercase text-gray-400 mb-2 block">
                    Admission number
                  </label>
                  <div className="flex items-center gap-x-2">
                    <h3 className="font-medium font-orbitron">
                      {studentDetails?.admissionNumber}
                    </h3>
                    <div className="flex items-center gap-x-[5px]">
                      {
                        <button
                          onClick={downloadStudentData}
                          disabled={savingPdf}
                          className="rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2"
                        >
                          {savingPdf ? (
                            <InlinePreloader />
                          ) : (
                            <ArrowDownTrayIcon className="w-4 h-4" />
                          )}
                        </button>
                      }
                      {/* <button onClick={()=>{setRejectingApplication(true)}} className='rounded-[8px] w-[30px] h-[30px] text-sm text-gray-600 bg-transparent transition duration-200 hover:bg-gray-600 hover:bg-opacity-20 flex items-center justify-center gap-x-2'>
                      <PrinterIcon className='w-4 h-4' />
                    </button> */}
                    </div>
                  </div>
                </div>
                <div className="w-full min-w-0 mt-1 relative">
                  {(canScrollLeft || canScrollRight) && (
                    <div className="absolute -top-7 right-0 mb-2 flex items-center justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          scrollByDirection(-1);
                        }}
                        disabled={!canScrollLeft}
                        className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-600 transition duration-200 hover:border-vcm-purple hover:text-vcm-purple disabled:cursor-not-allowed disabled:opacity-40"
                        aria-label="Scroll student tabs left"
                      >
                        <ChevronIcon className="h-4 w-4" />
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          scrollByDirection(1);
                        }}
                        disabled={!canScrollRight}
                        className="flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-600 transition duration-200 hover:border-vcm-purple hover:text-vcm-purple disabled:cursor-not-allowed disabled:opacity-40"
                        aria-label="Scroll student tabs right"
                      >
                        <ChevronIcon className="h-4 w-4 rotate-180" />
                      </button>
                    </div>
                  )}

                  <div
                    ref={scrollContainerRef}
                    className="scrollbar-hidden w-full max-w-full overflow-x-auto mb-4"
                  >
                    <div className="flex min-w-max items-center">
                      {studentTabs.map((tab, tabIndex) => {
                        if (tab.hideTab) {
                          return null;
                        }

                        return (
                          <button
                            key={tabIndex}
                            data-active={activeTabIndex === tabIndex}
                            className={`shrink-0 whitespace-nowrap py-2 px-5 rounded-t-[8px] transition duration-200 hover:border-gray-400 text-sm hover:text-vcm-purple ${activeTabIndex === tabIndex ? "border-b-2 border-vcm-purple text-vcm-purple bg-vcm-light-purple bg-opacity-10" : "border-b border-gray-200 text-gray-400"}`}
                            onClick={() => {
                              changeTab(tabIndex);
                            }}
                          >
                            {tab.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="py-2">
                  {studentTabs[activeTabIndex].value === "overview" && (
                    <>
                      <StudentOverview
                        student={studentDetails}
                        reload={reload}
                        setReload={setReload}
                      />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "details" && (
                    <>
                      <StudentDetails
                        student={studentDetails}
                        reload={reload}
                        setReload={setReload}
                      />
                    </>
                  )}

                  {studentTabs[activeTabIndex]?.value === "medicals" && (
                    <>
                      <StudentMedicals
                        student={studentDetails}
                        reload={reload}
                        setReload={setReload}
                      />
                    </>
                  )}

                  {studentTabs[activeTabIndex]?.value === "invoices" && (
                    <>
                      <StudentInvoices
                        student={studentDetails}
                        reload={reload}
                        setReload={setReload}
                      />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "academics" && (
                    <>
                      <StudentAcademics
                        student={studentDetails}
                        toggleTab={(tab) => {
                          toggleTabFromValue(tab);
                        }}
                      />
                    </>
                  )}

                  {/* {studentTabs[activeTabIndex].value === 'schedule' && <>
                    <StudentClassSchedule />
                  </>} */}

                  {studentTabs[activeTabIndex].value === "check-in-exeats" && (
                    <>
                      <StudentExeatsCheckIns student={studentDetails} />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "disciplinary" && (
                    <>
                      <StudentDisciplinary student={studentDetails} />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "sundry" && (
                    <>
                      <StudentSundry student={studentDetails} />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "feedback" && (
                    <>
                      <StudentFeedback student={studentDetails} />
                    </>
                  )}

                  {/* {studentTabs[activeTabIndex].value ===
                    "academic-transcript" && (
                    <>
                      <AcademicTranscript
                        student={studentDetails}
                        toggleTab={(tab) => {
                          toggleTabFromValue(tab);
                        }}
                      />
                    </>
                  )} */}

                  {studentTabs[activeTabIndex].value === "compile-results" && (
                    <>
                      <StudentResultsCompilation
                        student={studentDetails}
                        toggleTab={(tab) => {
                          toggleTabFromValue(tab);
                        }}
                      />
                    </>
                  )}

                  {studentTabs[activeTabIndex].value === "term-results" && (
                    <>
                      <StudentResults
                        student={studentDetails}
                        toggleTab={(tab) => {
                          toggleTabFromValue(tab);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          )
          // </div>
        }
      </div>
    </Layout>
  );
};

export default Student;
